import { authRoles } from '@/core/constants'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN } = authRoles

const Interests = () =>
  import(/* webpackChunkName: "users-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/interests',
    name: 'interests',
    component: Interests,
    meta: {
      title: 'Interests',
      auth: {
        roles: [ADMIN], // Roles permitidos
        redirect: '/auth/login', // Redirección si no está autenticado
        forbiddenRedirect: '/403', // Redirección si no tiene los roles necesarios
      },
    },
  },
]
